import { AccountSettingsStoreSlice } from './types';

export const defaultDeactivationState: AccountSettingsStoreSlice['deactivationStatus'] =
  {
    canReactivate: false,
    timeUntilReactivation: 0,
  };
